//dependencias
import React, { Component } from 'react';

//componentes
import MaternalVL from './maternalVeranitoL'

class Index extends Component {

    render(){
        return(
            <div>
                <MaternalVL />
            </div>
        );
    }

}
export default Index;